import {
  QueryKey,
  UseMutateAsyncFunction,
  useMutation,
  useQueryClient
} from 'react-query'

import {
  createMatchMe,
  createUnauthMatchMe,
  deleteMatchMe,
  matchMeToSavedSearchMutation,
  pauseMatchMe,
  resumeMatchMe
} from 'app/services/Api/matchMe'

import { matchMeKey } from './match-me.keys'

interface MutationConfig {
  createMatchMe: {
    key: QueryKey
    request: UseMutateAsyncFunction<void, string, MatchMeDTO, unknown>
  }
  deleteMatchMe: {
    key: QueryKey
    request: UseMutateAsyncFunction<void, string, number, unknown>
  }
  matchMeToSavedSearchMutation: {
    key: QueryKey
    request: UseMutateAsyncFunction<void, string, number, unknown>
  }
  createUnauthMatchMe: {
    key: QueryKey
    request: UseMutateAsyncFunction<void, string, MatchMeDTO, unknown>
  }
  pauseMatchMe: {
    key: QueryKey
    request: UseMutateAsyncFunction<void, string, number, unknown>
  }
  resumeMatchMe: {
    key: QueryKey
    request: UseMutateAsyncFunction<void, string, number, unknown>
  }
}

const matchMeMutationConfig: MutationConfig = {
  createMatchMe: {
    key: matchMeKey.createMatchMe(),
    request: createMatchMe
  },
  deleteMatchMe: {
    key: matchMeKey.deleteMatchMe(),
    request: deleteMatchMe
  },
  matchMeToSavedSearchMutation: {
    key: matchMeKey.matchMeToSavedSearchMutation(),
    request: matchMeToSavedSearchMutation
  },
  createUnauthMatchMe: {
    key: matchMeKey.createUnauthMatchMe(),
    request: createUnauthMatchMe
  },
  pauseMatchMe: {
    key: matchMeKey.pauseMatchMe(),
    request: pauseMatchMe
  },
  resumeMatchMe: {
    key: matchMeKey.resumeMatchMe(),
    request: resumeMatchMe
  }
}

export const useCreateMatchMeMutation = () => {
  const { createMatchMe: config } = matchMeMutationConfig

  const state = useMutation(config.key, config.request)

  return state
}

export const useDeleteMatchMeMutation = () => {
  const queryClient = useQueryClient()

  const { deleteMatchMe: config } = matchMeMutationConfig

  const state = useMutation(config.key, config.request, {
    onSuccess: () => {
      queryClient.invalidateQueries(matchMeKey.matchMe)
    }
  })

  return state
}

export const useMatchMeToSavedSearchMutation = () => {
  const { matchMeToSavedSearchMutation: config } = matchMeMutationConfig

  const state = useMutation(config.key, config.request)

  return state
}

export const useCreateUnauthMatchMeMutation = () => {
  const { createUnauthMatchMe: config } = matchMeMutationConfig

  const state = useMutation(config.key, config.request)

  return state
}

export const usePauseMatchMeMutation = () => {
  const { pauseMatchMe: config } = matchMeMutationConfig

  const state = useMutation(config.key, config.request)

  return state
}

export const useResumeMatchMeMutation = () => {
  const { resumeMatchMe: config } = matchMeMutationConfig

  const state = useMutation(config.key, config.request)

  return state
}
